export default __webpack_public_path__ + "static/media/black-skin-beauty-small.06bbfce7.png";